import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string; // optional SPA path
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: string; // text separator fallback e.g. "＜"
  separatorIconSrc?: string; // optional public path to icon asset
  separatorAlt?: string;
  className?: string;
  showLeadingSeparator?: boolean; // if true, also render separator before first item
}

// Accessible breadcrumb component with configurable separator icon or text.
export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  separator = '＜',
  separatorIconSrc,
  separatorAlt = '',
  className = '',
  showLeadingSeparator = false,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="パンくず" className={className}>
      <ol className="flex gap-[10px] text-[14px] text-black list-none p-0 m-0">
        {items.map((item, idx) => {
          const content = item.href ? (
            <Link to={item.href} className="hover:underline">
              {item.label}
            </Link>
          ) : (
            <span>{item.label}</span>
          );
          return (
            <li key={idx} className="flex items-center gap-[4px]">
              {(idx > 0 || (showLeadingSeparator && idx === 0)) &&
                (separatorIconSrc ? (
                  <img
                    src={separatorIconSrc}
                    alt={separatorAlt}
                    className="w-[12px] h-[12px] select-none"
                    aria-hidden={separatorAlt === ''}
                  />
                ) : (
                  <span className="text-[#1e1e1e] select-none" aria-hidden="true">
                    {separator}
                  </span>
                ))}
              {content}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
